/** @format */

export interface KillSwitch {
  /* @deprecated - This chain no longer exists and should not be added to new killswitches */
  calia?: boolean;
  dsg: boolean;
  g3?: boolean;
  gg: boolean;
  /* @deprecated - This chain no longer exists and should not be added to new killswitches */
  mj?: boolean;
  pl?: boolean;
  plf?: boolean;
  sm?: boolean;
  /* @deprecated - This chain no longer exists and should not be added to new killswitches */
  vrst?: boolean;
}

export interface KillSwitches {
  [key: string]: KillSwitch;
}
